/**
 * MEMOIRE brand logo — reusable SVG mark.
 * Variants:
 *   - "horizontal": icon left + wordmark stacked right (Navbar)
 *   - "stacked":    icon on top + wordmark centered below (Footer / Hero mark)
 *   - "mark":       icon only
 */
export default function MemoireLogo({
  variant = "horizontal",
  gold = "#C9A878",
  wordmarkColor,
  size = 40,
  className = "",
  "data-testid": testId,
}) {
  const Mark = (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className="shrink-0"
      aria-hidden="true"
    >
      {/* Two interlocking stadium shapes */}
      <rect
        x="18"
        y="14"
        width="42"
        height="60"
        rx="21"
        ry="21"
        fill="none"
        stroke={gold}
        strokeWidth="2.3"
      />
      <rect
        x="40"
        y="26"
        width="42"
        height="60"
        rx="21"
        ry="21"
        fill="none"
        stroke={gold}
        strokeWidth="2.3"
      />
    </svg>
  );

  const wm = wordmarkColor || gold;

  const Wordmark = ({ align = "left" }) => (
    <div
      className={`flex flex-col leading-none ${
        align === "center" ? "items-center" : "items-start"
      }`}
    >
      <span
        className="font-['Playfair_Display'] tracking-[0.25em]"
        style={{
          color: wm,
          fontSize: variant === "stacked" ? "28px" : "22px",
          lineHeight: 1,
        }}
      >
        MEMOIRE
      </span>
      <div
        className="mt-1.5 flex items-center gap-2"
        style={{ color: wm, opacity: 0.85 }}
      >
        <span className="h-px w-6 bg-current opacity-60" />
        <span className="text-[8px] uppercase tracking-[0.35em]">
          Dari Setiap Sudut.
        </span>
        <span className="h-px w-6 bg-current opacity-60" />
      </div>
    </div>
  );

  if (variant === "mark") {
    return (
      <span data-testid={testId} className={className}>
        {Mark}
      </span>
    );
  }

  if (variant === "stacked") {
    return (
      <div
        data-testid={testId}
        className={`flex flex-col items-center gap-4 ${className}`}
      >
        {Mark}
        <Wordmark align="center" />
      </div>
    );
  }

  // horizontal
  return (
    <div
      data-testid={testId}
      className={`flex items-center gap-3 ${className}`}
    >
      {Mark}
      <Wordmark align="left" />
    </div>
  );
}
